import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import polylabel from 'polylabel'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TBlockId, TProperty } from 'stores/fieldAssetStore/helperTypes'
import type { TSelectedFieldAssetsStoreState } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { getArgsForAnchorCoordinates } from '../getArgsForAnchorCoordinates'

export type TSetByArg = { block: TBlockId }

export const getAnchorCoordinatesForBlock = (block: TBlockId, property: TProperty) => {
  if (!property || !property?.blocks?.[block]) {
    return null
  }

  const { coordinates } = JSON.parse(property.blocks[block].geometry) as SharedTypes.TGeoJsonPolygon
  const [lng, lat] = polylabel([coordinates[0]], 1.0)
  const anchorCoordinates = { lng, lat }

  return anchorCoordinates
}

export const setBy = ({ block }: TSetByArg): Partial<TSelectedFieldAssetsStoreState> | null => {
  const allProperties = fieldAssetStore.getState()?.properties

  const property = Object.values(allProperties ?? {}).find((propertyData) => {
    return !!propertyData?.blocks?.[block]
  })

  if (!property) return null

  const anchorCoordinates = getAnchorCoordinatesForBlock(block, property)

  if (!anchorCoordinates) return null

  return getArgsForAnchorCoordinates({ anchorCoordinates, property, args: { block } })
}
